import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { find, map } from "lodash";
import Grid from "@mui/material/Grid";
import menujson from "../../Json/menu.json";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import * as React from "react";
import LibraryCard from "../../Components/Card/LibraryCard";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { getAssets } from "./Services";
import { taskSliceActions } from "../../Store/Slices/TaskSlice";
import { convertMinToSecond } from "../../Js/TimeAndDate";
import { fetchProduct } from "../../Store/Slices/ProductSlice";
import { currentAssetSliceActions } from "../../Store/Slices/CurrentAssetSlice";

const pathToParentMenu = ["root"];

const BookShelf = (props) => {
  const classes = useStyles();
  const navigation = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  let { productId, productVersion } = useSelector(
    (state) => state.defs.siteConfig.products[0]
  );

  let productData = useSelector((state) => state.product.productData);
  let selectedAssets = useSelector((state) => state.task.selectedAssets);
  let { bookLevel } = useSelector((state) => state.currentAsset);

  let [library, setLibrary] = useState(null);
  let [selectedLevel, setSelectedLevel] = useState(null);
  let [selectedLevelBooks, setSelectedLevelBooks] = useState([]);

  useEffect(() => {
    let data = productData;
    if (data) {
      if (typeof data == "string") {
        data = JSON.parse(data);
      }
      console.log("!@!@#$$@", data);
      let courseObj;
      if (typeof data[0]["course_data"] == "string") {
        courseObj = JSON.parse(data[0]["course_data"]);
      } else {
        courseObj = data[0]["course_data"];
      }
      setLibrary(courseObj["data"][1]["data"][1]);
      //setIsLoading(false);
    } else {
      const innerFun = async () => {
        dispatch(
          fetchProduct({
            productId: productId,
            productVersion: productVersion,
          })
        );
      };
      innerFun();
    }
  }, [productData]);

  useEffect(() => {
    if (library) {
      if (bookLevel != null) {
        setSelectedLevel(bookLevel);
      } else {
        setSelectedLevel(library["data"][0]["id"]);
        dispatch(
          currentAssetSliceActions.setBookLevel(library["data"][0]["id"])
        );
      }
    }
  }, [library, bookLevel]);

  useEffect(() => {
    let innerFun = async () => {
      if (selectedLevel) {
        console.log("DDDDDDDDggggg", library.data);
        let foundObj = find(library.data, { id: selectedLevel });
        if (foundObj) {
          let assets = await getAssets(map(foundObj.data, "id"));
          console.log("DDDDFFFFF", assets);
          let finalArray = [];
          if (assets.data) {
            console.log("ssss", assets.data);
            assets.data.forEach((val, index) => {
              let content = val.content;
              if (typeof content == "string") {
                content = JSON.parse(content);
              }
              finalArray.push({
                name: val.asset_name,
                img: content.content.epage.options.content[0].book.headerimg,
                id: val.asset_uid,
                duration: content.content.info.duration,
              });
            });
            console.log("DFGG", finalArray);
            setSelectedLevelBooks(finalArray);
          }
        }
      }
    };
    innerFun();
  }, [selectedLevel]);

  useEffect(() => {
    if (location.pathname.includes("Task")) {
      dispatch(taskSliceActions.setDurationFlag(true));
      dispatch(taskSliceActions.startDuration());
    }
  }, []);

  const bookclick = (book) => {
    console.log("location.pathname", location.pathname);
    let path = location.pathname.split("/");
    if (path[1].includes("Library")) {
      navigation(`/Library/Book/${book.id}`);
    } else {
      let findObj = selectedAssets.find((val) => {
        return val.id == book.id;
      });
      if (selectedAssets && selectedAssets.length > 0) {
        dispatch(taskSliceActions.removeAsset(selectedAssets[0].id));
      }
      if (!findObj) {
        dispatch(
          taskSliceActions.addAsset({
            id: book.id,
            name: book.name,
            duration: convertMinToSecond(book.duration),
          })
        );
      } else {
        dispatch(taskSliceActions.removeAsset(book.id));
      }
    }
  };

  return (
    <Grid container>
      {/* <GenerateMenu menuJson={menuJson} goToSubmenu={goToSubmenu}></GenerateMenu>
            {pathToParentMenu.length > 1 &&
                <Button variant="contained" color='secondary' onClick={backMenu}>Back</Button>
            } */}
      <Box sx={{ width: "100%", textAlign: "right", mt: 1 }}>
        <Button
          sx={{
            backgroundColor: "#F5F5F5",
            textTransform: "inherit",
            borderRadius: 10,
            fontWeight: "600",
            marginRight: 1,
            paddingY: 1,
           
            "@media (min-width: 1636px)": { fontSize: "1.2rem", px: 2 },
          }}
          onClick={() => {
            navigation(`/Library/ReaderBoard`);
          }}
        >
          Reader Board
        </Button>
        <FormControl size="small">
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={selectedLevel}
            onChange={(event) => {
              setSelectedLevel(event.target.value);
              dispatch(
                currentAssetSliceActions.setBookLevel(event.target.value)
              );
            }}
            sx={{
              borderRadius: 50,
              fontWeight: "500",
              color: "#DB8829",
              "@media (min-width: 1636px)": {
                fontSize: "1.4rem",
              },
            }}
          >
            {library &&
              library.data &&
              library.data.map((val, index) => {
                return (
                  <MenuItem
                    value={val.id}
                    key={`${index}_lvl`}
                    sx={{
                      "@media (min-width: 1636px)": { fontSize: "1.4rem" },
                    }}
                  >
                    {val.value}
                  </MenuItem>
                );
              })}
          </Select>
        </FormControl>
      </Box>
      <Grid item xs={12}  >
        <Grid sx={{ position: "relative" }}>
          <Grid sx={{ color: "primary.main", pl: 7 }}>
            <span></span>
          </Grid>
          <Grid
            container
            sx={{
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: "flex-start",
              gap: 6,
              pl: 2,
              pr: 2,
              overflow: "auto",
            }}
          >
            {selectedLevelBooks &&
              selectedLevelBooks.map((val, index) => {
                return (
                  <span key={`${index}_lvl`}>
                    <LibraryCard
                      title={val.name}
                      img={val.img}
                      press={() => {
                        bookclick(val);
                      }}
                      selected={
                        selectedAssets && selectedAssets.length > 0
                          ? selectedAssets[0]["id"] == val.id
                          : false
                      }
                    />
                  </span>
                );
              })}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
    height: "80vh",
    overflow: "auto",
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default BookShelf;
